import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "compilationTitle", "compilationBoard", "billingsTitle", "billingsTable", "mainCard",
                    "bodyTable", "footerTable", "content", "goalLeadInput", "mainDashboard"]

  connect() {
    this.controllerName = `financials--books--receivables--dashboard--main`
    this.loader = this.getControllerByIdentifier("app--helpers--loaders").loader()
    this.cardLoader = this.getControllerByIdentifier("app--helpers--loaders").cardLoader()
    this.reload = false
    this.load = false
    this.application.permissions = {}
    this.application.permissions = []
    this.application.meds = []
    this.application.channels = []
    this.application.chart_accounts = []
    this.application.providers = []
    this.application.tickets = []
    this.application.addons = []
    
    this.application.clients = []
    this.application.contracts = []
    this.application.receivables = []
    this.application.billings = []
    this.application.billing_dates = []
    this.doMainGrid()

    // 1 - this.getCurrentUserPermissions
    // 2 - this.getFinancialDates
    // 3 - this.getReceivables
    // 4 - this.getProviders
    // 5 - this.getTickets
    // 6 - this.getReceivableTeam
    // 7 - this.getMeds
    // 8 - this.getManageTeam
    // 9 - this.getChartAccounts
    // 10 - this.getChannels
    // 11 - this.getBills
    // 12 - this.getPermissions
    // 13 - this.Notes
  }

  doMainDashboard() {
    this.doPageGrid()
  }

  doPageGrid() {
    var html = `<div class="row my-2" data-${this.controllerName}-target="mainDashboard">
                    <div class="col-6 px-2">
                      <div class="row my-2 w-100">
                        <div class="col-12">
                          <h6 class="mb-0 text-center pointer" data-action="click->${this.controllerName}#refreshCompilation" data-${this.controllerName}-target="compilationTitle">${this.loader}</h6>
                          <hr class="my-1">
                          <div class="row" data-${this.controllerName}-target="compilationBoard" data-controller="financials--books--receivables--dashboard--compilation">
                            ${this.cardGridPreloader()}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6 px-2">
                      <div class="row my-2 w-100">
                        <div class="col-12 px-0">
                          <h6 class="mb-0 text-center pointer" data-${this.controllerName}-target="billingsTitle">${this.loader}</h6>
                          <hr class="mt-1">
                          <div class="row my-2" data-${this.controllerName}-target="billingsTable" data-controller="financials--books--receivables--dashboard--billings">
                            ${this.cardGridPreloader()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.contentTarget.innerHTML = html)
    }).then(() => {
      if (controller.load) {
        controller.getControllerByIdentifier(`financials--books--receivables--dashboard--billings`).doBillingList()
        controller.getControllerByIdentifier(`financials--books--receivables--dashboard--compilation`).doCompilationCard()
      }
    })
  }

  cardGridPreloader() {
    var html = `<div class="col-4 my-2">
                  ${this.cardLoader}
                </div>
                <div class="col-4 my-2">
                  ${this.cardLoader}
                </div>
                <div class="col-4 my-2">
                  ${this.cardLoader}
                </div>
                <div class="col-4 my-2">
                  ${this.cardLoader}
                </div>
                <div class="col-4 my-2">
                  ${this.cardLoader}
                </div>
                <div class="col-4 my-2">
                  ${this.cardLoader}
                </div>`

    return html
  }

  doMainGrid() {
    var html = `<div class="row">
                  <div class="col-12 px-0" data-controller="financials--books--receivables--contracts--dashboard
                                                            financials--books--receivables--conciliations--dashboard
                                                            financials--books--receivables--billings--dashboard
                                                            financials--books--receivables--entities--dashboard
                                                            financials--books--receivables--liquidations--dashboard
                                                            financials--books--receivables--tickets--dashboard
                                                            financials--books--receivables--annual--dashboard" data-${this.controllerName}-target="content">
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.doMainDashboard()
      controller.getCurrentUserPermissions()
    })
  }
  
  refreshCompilation() {
    this.getControllerByIdentifier("financials--books--receivables--dashboard--compilation").refreshCompilation()
  }

  refreshBillings() {
    this.getControllerByIdentifier(`financials--books--receivables--dashboard--billings`).refreshBillings()
  }

  finishLoadPage() {
    var response = { type: `success`, message: `Página carregada com sucesso!` }
    this.load = true

    if (this.reload) {
      this.getControllerByIdentifier("financials--books--receivables--dashboard--dates").runDashboardsHtml()
      this.getControllerByIdentifier("financials--books--receivables--dashboard--submenu").doBadgeCounts()
    } else {
      this.getControllerByIdentifier("financials--books--receivables--dashboard--main").doMainDashboard()
      this.getControllerByIdentifier("financials--books--receivables--dashboard--submenu").doSubmenuHtml()
      this.getControllerByIdentifier("financials--books--receivables--dashboard--meds").doMedHtml()
    }
    this.application.current_date.data_loaded = true

    this.getControllerByIdentifier(`app--helpers--pre-page-load`).closeLoadModal()
    this.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
  }

  getTickets() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Tickets`, value: 95 })

    var data = { ticket: { board_id: this.application.current_date.id, board_type: "financial_receivables" }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_tickets` } }
    const url = "/users/works/activities/tickets/list_by_board"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(element => {
          controller.application.tickets[controller.application.tickets.length] = element
        })

        controller.finishLoadPage()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getBillings() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Faturas`, value: 90 })

    var date = new Date(this.application.current_date.year, this.application.current_date.month - 1, 1)
    const data = { billing: { active: true, date_id: this.application.current_date.id }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_billings` } }
    const url = "/financials/integrations/bankings/iugu/billings/list_by_date"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          var currentBillingIds = controller.mapElements(controller.application.billings, `id`)
          var refreshBillingIds = controller.mapElements(response.data.cln, `id`)

          response.data.cln.forEach(billing => {
            if (currentBillingIds.includes(billing.id) && refreshBillingIds.includes(billing.id)) {
              controller.application.billings.forEach((element, i) => {
                if (element.id == billing.id) {
                  controller.application.billings.splice(controller.application.billings.indexOf(element), 1, billing)
                }
              })
            } else if (!currentBillingIds.includes(billing.id) && refreshBillingIds.includes(billing.id)) {
              controller.application.billings[controller.application.billings.length] = billing
            }
          })
        }

        controller.getTickets()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getReceivables() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Recebíveis`, value: 80 })

    var date = new Date(this.application.current_date.year, this.application.current_date.month - 1, 1)
    const data = { receivable: { active: true, date_id: this.application.current_date.id }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_entities` } }
    const url = "/financials/books/receivables/entities/list_by_date"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          response.data.cln.forEach(element => {
            controller.application.receivables[controller.application.receivables.length] = element
          })
        }

        controller.getBillings()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getAddonsByDate() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Complementos de Contratos`, value: 70 })

    const data = { addon: { active: true, date_token: this.application.current_date.token }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_addons` } }
    const url = "/financials/books/clients/addons/list_by_date_token"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          response.data.cln.forEach(element => {
            controller.application.addons[controller.application.addons.length] = element
          })
        }

        controller.getReceivables()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  loadDateData() {
    if (this.application.current_date.data_loaded == false) {
      if (!this.getControllerByIdentifier("app--helpers--page-load")) {
        this.getControllerByIdentifier(`app--helpers--pre-page-load`).openLoadModal({ submessage: `Carregando Informações da Competência ${this.application.current_date.name}` })
      }

      this.getBillings()
      // this.getAddonsByDate()
      // this.getReceivables()
      // this.finishLoadPage()
    } else {
      this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Finalizando`, value: 75 })
      this.finishLoadPage()
    }
  }

  getAddonsByStatus() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Complementos de Contratos`, value: 70 })

    const data = { addon: { active: true, status: `active` }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_addons` } }
    const url = "/financials/books/clients/addons/list_by_status"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          response.data.cln.forEach(element => {
            controller.application.addons[controller.application.addons.length] = element
          })
        }

        controller.loadDateData()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getFinancialDates() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Competências`, value: 65 })

    var t0 = new Date()
    // console.log(t0.getTime())

    const data = { date: { active: true, subdomain: `receivables` }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_dates` } }
    const url = "/financials/config/dates/list_with_subdomain"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        var currentDates = []
        var today = new Date()

        response.data.cln.forEach(element => {
          if (today.getFullYear() > element.year) {
            currentDates[currentDates.length] = element
          } else if (today.getFullYear() == element.year && (today.getMonth() + 1) >= element.month) {
            currentDates[currentDates.length] = element
          }
        })

        controller.application.dates = currentDates
        controller.application.current_date = currentDates[0]

        controller.application.current_receivable_compilation = currentDates[0].receivable_compilation
        controller.application.current_regimes = currentDates[0].regimes

        controller.getControllerByIdentifier("financials--books--receivables--dashboard--dates").doDatesHTML()

        var t2 = new Date()
        // console.log((t2.getTime() - t0.getTime())/1000)


        controller.getAddonsByStatus()
        // controller.loadDateData()
        // controller.getControllerByIdentifier("commercial--dashboards--broadcast").getRoom()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getReceivableTeam() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Tickets`, value: 60 })

    const data = { current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_entities` } }
    const url = "/financials/config/teams/list_receivable_team"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {

        controller.application.team_list = response.data.cln
        controller.getFinancialDates()

      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getClients() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Clientes`, value: 55 })

    const data = { client: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_clients` } }
    const url = "/financials/books/clients/entities/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.clients = response.data.cln
        }
        controller.getReceivableTeam()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getChartAccounts() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Plano de Contas`, value: 50 })

    const data = { chart_account: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_chart_accounts` } }
    const url = "/financials/books/statements/chart_accounts/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {

        controller.application.chart_accounts = response.data.cln
        controller.getClients()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getProviders() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Fornecedores`, value: 40 })

    const data = { provider: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_providers` } }
    const url = "/financials/books/statements/providers/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.providers = response.data.cln
        controller.getChartAccounts()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getChannels() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Canais de Recebimento`, value: 30 })

    const data = { channel: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_channels` } }
    const url = "/financials/books/statements/channels/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        controller.application.channels = response.data.cln
        controller.getProviders()
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })
  }

  getMeds() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).progressCountMessage({ submessage: `Carregando Meds`, value: 20 })
    var data = { med: { active: true }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_meds` } }
    const url = "/financials/config/meds/list"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          controller.application.meds = response.data.cln
        } else {
          controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 3000)
        }
        controller.application.current_med = { id: ``, cnpj: ``, name: `Grupo` }

        controller.getChannels()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  getCurrentUserPermissions() {
    this.getControllerByIdentifier(`app--helpers--pre-page-load`).openLoadModal({ submessage: `Carregando Permissões` })

    const data = { permissions: { subdomain: `financial_book_receivables` }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_receivable_permissions`, account_kind: this.application.current_user.account_kind } }
    const url = "/users/permissions/policies/list_by_domain"

    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        response.data.cln.forEach(permission => {
          controller.application.permissions[permission.name] = permission.data
        });

        controller.getMeds()
        // controller.getControllerByIdentifier("financials--books--receivables--dashboard--submenu").doSubmenuHtml()
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
        // window.location.reload()
      })
  }


  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------
  // ------------------------------------------------------------------------------------------

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  currencyMask(ev) {
    this.getControllerByIdentifier("app--helpers--numbers").changeNumberToCurrency(ev)
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = `financials--books--receivables--dashboard--main`
    this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0

      if (controller.updatePayble) {
        len += 1
      }

      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    })
    return results
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}